import React, { useEffect } from "react";
import useStyles from "../common/Styles";
import { Box } from "@material-ui/core";
import ChartTitle from "../common/ChartTitle";
import IndustryMap from "./IndustryMap";
import IndustryShortage from "./IndustryShortage";
import userActions from '../common/actions';
import appActions from '../../../app/actions';

const ChartView = (props) => {
  const classes = useStyles();
  const { setWaterUserChart } = userActions();
  const { chart } = props;
  const { setChartDrawerStateToClose } = appActions();

  const componentUnmountHook = () => {
    return () => setWaterUserChart(0);
  }
  useEffect(componentUnmountHook, []);

  return (
    <Box className={classes.chartView} onClick={()=> { setChartDrawerStateToClose() }}>
      <ChartTitle
        floating={chart.floating_title}
        title={chart.title}
        subtitle={chart.subtitle}
        background={chart.floating_title ? "#EDEDED" : "transparent"}
      />

      {
        {
          title_map: <IndustryMap />,
          shortage_impacts_to_industry: <IndustryShortage />,
        }[chart.id]
      }
    </Box>
  );
};

export default ChartView;
